import React, { useEffect, useState } from 'react';
import client from '../../api/client';
import { card, inputCls } from './LegalConfigEditor';

const STATUSES = ['received', 'verifying', 'in_progress', 'completed', 'denied'];

const Row = ({ r, onUpdate }) => {
  const [note, setNote] = useState('');
  return (
    <tr data-testid={`privacy-row-${r.reference}`} className="border-t border-[#F2E8DE] align-top">
      <td className="py-2 pr-3 font-mono text-xs">{r.reference}</td>
      <td className="py-2 pr-3"><p>{r.name}</p><p className="text-xs text-[#9A8A7E]">{r.email}{r.phone ? ` · ${r.phone}` : ''}</p></td>
      <td className="py-2 pr-3 text-xs"><span className="px-2 py-0.5 rounded-full bg-[#F4E4DA] text-[#7B2C3B]">{r.request_type.replace('_', ' ')}</span><p className="text-[#9A8A7E] mt-1">{r.relationship.replace('_', ' ')}</p></td>
      <td className="py-2 pr-3 text-xs max-w-xs text-[#5A5A5A]">{r.details || '—'}{(r.notes || []).map((n, i) => <p key={i} className="text-[#9A8A7E] mt-1">↳ {n.text}</p>)}</td>
      <td className="py-2 pr-3 text-xs whitespace-nowrap">{new Date(r.created_at).toLocaleDateString()}<p className="text-[#9A8A7E]">due {new Date(r.due_by).toLocaleDateString()}</p></td>
      <td className="py-2 space-y-1 min-w-[160px]">
        <select data-testid={`privacy-status-${r.reference}`} value={r.status} onChange={(e) => onUpdate(r.id, e.target.value, note).then(() => setNote(''))} className={inputCls + ' text-xs py-1'}>
          {STATUSES.map((s) => <option key={s} value={s}>{s.replace('_', ' ')}</option>)}
        </select>
        <input data-testid={`privacy-note-${r.reference}`} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Note (saved with status change)" className={inputCls + ' text-xs py-1'} />
      </td>
    </tr>
  );
};

export default function PrivacyQueue({ toast, onChange }) {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState('');
  const load = () => client.get('/admin/compliance/privacy-requests', { params: { status: status || undefined } }).then(({ data }) => setRows(data.requests)).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [status]);

  const update = async (id, newStatus, note) => {
    try {
      await client.patch(`/admin/compliance/privacy-requests/${id}`, { status: newStatus, note: note || null });
      toast({ title: `Marked ${newStatus.replace('_', ' ')}` });
      load(); onChange?.();
    } catch (e) {
      toast({ title: 'Update failed', description: e.message, variant: 'destructive' });
    }
  };

  return (
    <section data-testid="privacy-queue" className={card}>
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <h3 className="font-serif text-xl text-[#2A2A2A]">Privacy requests</h3>
        <select data-testid="privacy-filter" value={status} onChange={(e) => setStatus(e.target.value)} className="text-xs px-3 py-1.5 rounded-full border border-[#EFE3D8] bg-white">
          <option value="">All statuses</option>
          {STATUSES.map((s) => <option key={s} value={s}>{s.replace('_', ' ')}</option>)}
        </select>
      </div>
      {rows.length === 0 ? <p className="text-sm text-[#9A8A7E]">No requests yet. The public form lives at /privacy-request.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[11px] uppercase tracking-wider text-[#9A8A7E]"><th className="pb-2">Ref</th><th>Requester</th><th>Type</th><th>Details</th><th>Dates</th><th>Status</th></tr></thead>
            <tbody>{rows.map((r) => <Row key={r.id} r={r} onUpdate={update} />)}</tbody>
          </table>
        </div>
      )}
    </section>
  );
}
